"use strict";

import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/regenerator/index.js";
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React, { useState } from "react";
import { FolderComponent } from "../FolderTree/FolderComponent/FolderComponent";
import { Folder, ChevronRight, ChevronLeft, Tick, AddFolder } from "../../icons";
import OnClickOutside from "../../../utils/OnClickOutside";
import classNames from "classnames";
import TextInput, { TextInputSize } from "../TextInput/TextInput";
import { Alert, AlertType } from "../Alert";
import Button, { ButtonType, ButtonSize } from "../Button/Button";
import Tooltip from "../Tooltip/Tooltip";
import { Text } from "../Text";
import { KeyType } from "../../../utils";
import IconButton from "../IconButton/IconButton";
import { Stack } from "../Stack/Stack";
var RemoteDataStatus = /* @__PURE__ */function (RemoteDataStatus2) {
  RemoteDataStatus2["NotRequested"] = "notRequested";
  RemoteDataStatus2["Loading"] = "loading";
  RemoteDataStatus2["Success"] = "success";
  RemoteDataStatus2["Error"] = "error";
  return RemoteDataStatus2;
}(RemoteDataStatus || {});
export var FolderDropdown = function FolderDropdown(props) {
  var _useState = useState(props.initialFolderId ? props.initialFolderId : ""),
    _useState2 = _slicedToArray(_useState, 2),
    currentFolderId = _useState2[0],
    setCurrentFolderId = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showAddFolder = _useState4[0],
    setAddFolder = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    newFolderName = _useState6[0],
    setNewFolderName = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var folders = props.folders.status == "success" /* Success */ ? props.folders.data : [];
  var rootFolder = {
    id: "",
    name: props.rootFolderName
  };
  var folderLookup = folders.find(function (folder) {
    return folder.id == currentFolderId;
  });
  var currentFolder = folderLookup ? folderLookup : rootFolder;
  var children = folders.filter(function (folder) {
    return folder.parent == currentFolderId;
  });
  var onClickOutside = new OnClickOutside([".new-folder-form"], function () {
    toggleAddFolderInput(false);
  });
  var onClickOutsideError = new OnClickOutside([".folder-dropdown__error"], function () {
    setErrorMessage("");
  });
  var toggleAddFolderInput = function toggleAddFolderInput(isOpen) {
    setAddFolder(isOpen);
    if (isOpen) onClickOutside.startListening();else onClickOutside.stopListening();
  };
  var toggleErrorMessage = function toggleErrorMessage(error) {
    setErrorMessage(error);
    if (error) onClickOutsideError.startListening();else onClickOutsideError.stopListening();
  };
  var createFolder = function createFolder() {
    return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var id;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return props.onAddFolder(newFolderName, currentFolderId ? currentFolderId : void 0);
          case 3:
            id = _context.sent;
            setCurrentFolderId(id);
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            toggleErrorMessage("Unable to create folder.");
          case 10:
            toggleAddFolderInput(false);
            return _context.abrupt("return", false);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
  };
  var moveUpFolder = function moveUpFolder(folder) {
    setCurrentFolderId(folder.parent ? folder.parent : rootFolder.id);
  };
  var addFolderForm = /* @__PURE__ */React.createElement("div", {
    className: "new-folder-form"
  }, /* @__PURE__ */React.createElement(FolderComponent, {
    name: "New Folder Placeholder",
    element: "div",
    icon: /* @__PURE__ */React.createElement(Folder, null),
    selected: false,
    overrideNameComponent: /* @__PURE__ */React.createElement(Stack, {
      direction: "horizontal",
      gap: "xxs"
    }, /* @__PURE__ */React.createElement(TextInput, {
      label: "New Folder Name",
      labelHidden: true,
      placeholder: "Type Something",
      size: TextInputSize.Small,
      onChange: function onChange(folderName) {
        return setNewFolderName(folderName);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === KeyType.Enter) createFolder();
        if (e.key === KeyType.Escape) toggleAddFolderInput(false);
      },
      autoFocus: true
    }), /* @__PURE__ */React.createElement(IconButton, {
      type: ButtonType.Secondary,
      icon: /* @__PURE__ */React.createElement(Tick, null),
      size: ButtonSize.Small,
      onClick: function onClick() {
        createFolder();
      }
    }))
  }));
  return /* @__PURE__ */React.createElement("div", {
    className: classNames("folder-dropdown", {
      "parent-selected": currentFolder.id == ""
    })
  }, /* @__PURE__ */React.createElement(FolderComponent, {
    name: currentFolder.name,
    icon: currentFolder.id != "" ? /* @__PURE__ */React.createElement(ChevronLeft, {
      opacity: 50
    }) : /* @__PURE__ */React.createElement(React.Fragment, null),
    onClick: function onClick() {
      return moveUpFolder(currentFolder);
    },
    selected: false
  }), /* @__PURE__ */React.createElement("div", {
    className: "folder-dropdown__children"
  }, props.folders.status == "success" /* Success */ ? children.length > 0 ? children.map(function (folder, i) {
    return /* @__PURE__ */React.createElement(FolderComponent, {
      key: i,
      name: folder.name,
      icon: /* @__PURE__ */React.createElement(Folder, null),
      onClick: function onClick() {
        return setCurrentFolderId(folder.id);
      },
      selected: false,
      endElement: folders.filter(function (item) {
        return item.parent == folder.id;
      }).length ? /* @__PURE__ */React.createElement(ChevronRight, null) : /* @__PURE__ */React.createElement(React.Fragment, null)
    });
  }) : !showAddFolder ? /* @__PURE__ */React.createElement(Text, {
    size: "s"
  }, "No folders here") : "" : "Loading", showAddFolder && addFolderForm), /* @__PURE__ */React.createElement("div", {
    className: "folder-dropdown__controls"
  }, /* @__PURE__ */React.createElement(Tooltip, {
    content: "New Folder"
  }, /* @__PURE__ */React.createElement(IconButton, {
    icon: /* @__PURE__ */React.createElement(AddFolder, null),
    "aria-label": "New Folder",
    onClick: function onClick() {
      return toggleAddFolderInput(!showAddFolder);
    },
    size: ButtonSize.Small
  })), /* @__PURE__ */React.createElement(Button, {
    className: "folder-dropdown__controls--select",
    size: ButtonSize.Small,
    type: ButtonType.Primary,
    onClick: function onClick() {
      return props.onSelect(currentFolderId);
    }
  }, "Select Folder")), errorMessage && /* @__PURE__ */React.createElement(Alert, {
    className: "folder-dropdown__error",
    heading: "Error",
    alertType: AlertType.Error
  }, errorMessage));
};